import React from 'react'

const BackgroundImage = ({rotate}) => {
  return (
    <div className={rotate ? 'background_images' :'backgroundImage'}>
    </div>
  )
}

export default BackgroundImage